module.exports = __webpack_public_path__ + "51b90023abd4bcabb489786debcb0bdd.MP3";